export default __webpack_public_path__ + "static/media/LogoRegioneAMP_color.e3e63e4f.png";